module.exports = __webpack_public_path__ + "img/error_page_icon.b14b7578.svg";